import IndexedSearchList from './indexed-search-list';

export default IndexedSearchList;
